import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_INVENTORY_QUERY_KEY } from '~/features/hooks/useGetInventory'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { InventoryV2 } from '~/supabase/types'

export const useBatchUpdateInventory = () => {
  const { mutate: notifyError } = useNotifyError()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['patch-inventory'],
    mutationFn: async (
      payload: Array<
        Pick<InventoryV2, 'id' | 'location' | 'stock_code_v2' | 'cost'> &
          Partial<Omit<InventoryV2, 'id' | 'location' | 'stock_code_v2'>>
      >
    ) => {
      const { error } = await supabaseApi.from('inventory_v2').upsert(payload)

      if (error) {
        toast.error('Inventory update failed')
        notifyError({
          message: 'Inventory update failed.',
          data: { payload },
          error,
          function: 'usePatchInventory',
        })
        throw error
      }
      toast.success('Inventory updates successful.')
      queryClient.invalidateQueries({ queryKey: [GET_INVENTORY_QUERY_KEY] })
    },
  })
}
